import { useKrakenMutation } from '@/components/GraphQLClient';
import { useScopedTokenContext } from '@/context';
import SubmitCustomerFeedback from '@/hooks/CHISurvey/useSubmitCustomerFeedback/SubmitCustomerFeedback.graphql';
import {
  useSuccessHandler,
  CUSTOMER_FEEDBACK_JOURNEY_KEY_OPTIONS,
} from '@/hooks/CHISurvey/useSubmitCustomerFeedback/useSuccessHandler';

import { submitCustomerFeedbackSchema } from '../validations';

export { CUSTOMER_FEEDBACK_JOURNEY_KEY_OPTIONS } from '@/hooks/CHISurvey/useSubmitCustomerFeedback/useSuccessHandler';

export const useSubmitCustomerFeedback = ({
  journeyKey,
}: {
  journeyKey?: CUSTOMER_FEEDBACK_JOURNEY_KEY_OPTIONS;
} = {}) => {
  const { scopedToken } = useScopedTokenContext();
  const onSuccess = useSuccessHandler(journeyKey);

  return useKrakenMutation({
    mutation: (_: any) => SubmitCustomerFeedback,
    validateFn(response) {
      return submitCustomerFeedbackSchema.validate(response);
    },
    ...(scopedToken && {
      requestHeaders: {
        Authorization: scopedToken,
      },
    }),
    onSuccess,
    gcTime: 0,
  });
};
